import { Intent } from "@blueprintjs/core"

import { OrderStatus, WaveStatus } from "../types/common"
import { Wave } from "../types/wave"

interface ToasterConfig {
  message: string
  intent: Intent
  timeout?: number
}

export const getWaveResultToaster = (wave: Wave): ToasterConfig => {
  const rejectedOrders = wave.orders.filter(order => order.status === OrderStatus.REJECTED)
  const locateFailedOrders = wave.orders.filter(
    order =>
      order.status === OrderStatus.LOCATE_FAILED || order.status === OrderStatus.LOCATE_ERROR,
  )
  const locatePendingOrders = wave.orders.filter(
    order => order.status === OrderStatus.LOCATE_SUBMITTED,
  )

  // Handle rejected orders as errors
  if (rejectedOrders.length > 0) {
    const rejectedDetails = rejectedOrders.map(order => order.execution_summary).join(", ")
    const errorMessage = `Wave partially submitted: ${rejectedOrders.length} order(s) were rejected (${rejectedDetails}).`

    return {
      message: errorMessage,
      intent: Intent.DANGER,
      timeout: 0,
    }
  }

  if (locatePendingOrders.length > 0) {
    const locateCodes = locatePendingOrders
      .map(order => order.instrument?.bloomberg_code || "Unknown")
      .join(", ")

    return {
      message: `Locate pending for ${locatePendingOrders.length} order(s) (${locateCodes}) - checking with Flextrade for availability`,
      intent: Intent.PRIMARY,
      timeout: 5000,
    }
  }

  if (locateFailedOrders.length > 0) {
    const locateCodes = locateFailedOrders
      .map(order => order.instrument?.bloomberg_code || "Unknown")
      .join(", ")

    return {
      message: `Locate failed for ${locateFailedOrders.length} order(s) (${locateCodes}) - please contact support`,
      intent: Intent.DANGER,
    }
  }

  if (wave.status === WaveStatus.FAILED) {
    return {
      message:
        "Wave execution failed, check the execution details below for more information or contact support",
      intent: Intent.DANGER,
    }
  }

  if (wave.status === WaveStatus.NOT_PASSED) {
    return {
      message:
        "Wave validation did not pass, check the execution details below for more information or contact support",
      intent: Intent.DANGER,
    }
  }

  return {
    message: "Wave submitted successfully",
    intent: Intent.SUCCESS,
  }
}
